import { InputField } from "@/components/input-field/InputField";
import { CustomPopover } from "@/components/popover/CustomPopover";
import { SelectComponent } from "@/components/select/Select";
import { AppColors } from "@/styles/colors";
import { Badge, Box, Button, Flex, HStack, Text } from "@chakra-ui/react";
import { Filter, Search } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
import { Control, FieldValues, UseFormHandleSubmit } from "react-hook-form";

interface Props {
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  openFilters: boolean;
  setOpenFilters: Dispatch<SetStateAction<boolean>>;
  submitFilters: (event: FieldValues) => Promise<void>;
  clearFilters: () => Promise<void>;
  control?: Control<FieldValues>;
  disableFilters?: boolean;
  loadingFilters?: boolean;
  filtersApplied?: boolean;
  disableClear?: boolean;
}

export const ProductsFilter = ({
  openFilters,
  disableFilters,
  loadingFilters,
  filtersApplied,
  disableClear,
  control,
  submitFilters,
  handleSubmit,
  setOpenFilters,
  clearFilters,
}: Props) => {
  return (
    <Flex width="100%" paddingY="10px" justifyContent="flex-end">
      <HStack gap="10">
        <CustomPopover
          open={openFilters}
          onOpenChange={(e) => setOpenFilters(e.open)}
          triggerComponent={
            <Box position="relative" display="inline-block">
              <Button
                variant="outline"
                paddingX="12px"
                height="32px"
                disabled={disableFilters || loadingFilters}
              >
                <Filter />
                <Text fontWeight={600} fontSize="14px">
                  Filtrar
                </Text>
              </Button>
              {filtersApplied && (
                <Badge
                  position="absolute"
                  top="-4px"
                  right="-4px"
                  bg="red.500"
                  color="white"
                  fontSize="10px"
                  borderRadius="full"
                  px="2"
                  py="0.5"
                >
                  !
                </Badge>
              )}
            </Box>
          }
          bodyComponent={
            <Flex
              as="form"
              flexDir="column"
              padding="25px"
              gap="15px"
              onSubmit={handleSubmit(submitFilters)}
            >
              <Flex alignItems={"center"} justifyContent="space-between">
                <Text fontWeight={600} fontSize="20px">
                  Filtrar
                </Text>

                <Button
                  variant="plain"
                  color={AppColors.BLUE_TEXT}
                  fontWeight={600}
                  onClick={clearFilters}
                  disabled={loadingFilters || disableClear}
                  loading={loadingFilters}
                >
                  Limpiar filtros
                </Button>
              </Flex>

              <Flex flexDir="column" gap="15px">
                <Flex gap="15px">
                  <Box flex="1">
                    <InputField
                      inputName="name"
                      labelText="Nombre"
                      control={control}
                      placeholder="Ingresar nombre"
                      disabled={loadingFilters}
                      startElement={<Search />}
                    />
                  </Box>

                  <Box flex="1">
                    <InputField
                      inputName="descripcion"
                      labelText="Descripción"
                      control={control}
                      placeholder="Ingresar descripción"
                      disabled={loadingFilters}
                      startElement={<Search />}
                    />
                  </Box>
                </Flex>

                <Flex gap="15px">
                  <Box flex="1">
                    <SelectComponent
                      name="activo"
                      labelText="Estado"
                      placeholder="Seleccionar estado"
                      control={control}
                      disabled={loadingFilters}
                      clearable
                      items={[
                        { label: "Activo", value: true },
                        { label: "Desactivado", value: false },
                      ]}
                    />
                  </Box>
                  <Box flex="1">
                    {/* Espacio vacío para mantener el layout */}
                  </Box>
                </Flex>
              </Flex>

              <Button
                bgColor={AppColors.GREEN_PRIMARY}
                type="submit"
                loading={loadingFilters}
                disabled={loadingFilters || disableFilters}
                position="relative"
                zIndex={1}
              >
                Aplicar filtros
              </Button>
            </Flex>
          }
        />
      </HStack>
    </Flex>
  );
};
